import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonModal, IonTitle, IonToolbar } from "@ionic/react";
import { Glob, useLoc } from "functions/Language";
import { FC, ReactNode, useState } from "react";


export const OptionsButton : FC<{
  icon : string,
  title : string,
  children : (Close : () => void) => ReactNode
}> = (props) => {
  const loc = useLoc(glob);
  const [isOpen, setOpen] = useState(false);

  function Close() {
    setOpen(false);
  }

  return <>
    <IonButton onClick={() => setOpen(true)}>
      <IonIcon icon={props.icon} />
    </IonButton>
    <IonModal isOpen={isOpen} onWillDismiss={Close}>
      <IonHeader>
        <IonToolbar color="tertiary">
          <IonTitle>{props.title}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={Close}>{loc.close}</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent className="padded">
        {props.children(Close)}
      </IonContent>
    </IonModal>
  </>
}

const glob = Glob({
	en: {
		close: "Close",
	},
	cs: {
		close: "Zavřít",
	},
	pg: {
		close: "Fechar",
	},
	es: {
		close: "Cerrar",
	},
} as const);

